import styled from 'styled-components'
import { P } from 'common/typography'
import { TransparentButton } from 'common/button'
import { AiFillFacebook, AiFillTwitterSquare } from 'react-icons/ai'
import { useCertificate } from 'querys/certificates'
import useLocation from 'hooks/use-location'
import Share from 'common/share'

const ShareBtn = styled(TransparentButton)`
  background: var(--neutral100);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ disabled }) => disabled && `
    background: var(--neutral90);
    cursor: not-allowed;
  `}
  &:hover {
    background: var(--neutral90);
  }
  &:active {
    background: var(--black);
  }
`

const CertificateSocialStyled = styled.div`
  margin: 0 auto;
  margin-block-start: 16px;
  width: fit-content;
  .share-btns {
    margin-block-start: 8px;
    display: flex;
    gap: 16px;
    justify-content: center;
  }
  @media(min-width: 1024px) {
    margin-block-start: 24px;
  }
`

function CertificateSocial() {
  const { href: url } = useLocation()
  const {
    data: {
      is_owner, certificate_png, course: { slug, title },
    },
  } = useCertificate()

  const twitterMessage = `He completado el ${title}`

  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${url}}`
  const twitterLink = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(twitterMessage)}`

  if (!is_owner) return null

  return (
    <CertificateSocialStyled>
      <P fontWeight="700" align="center">Compartir en:</P>
      <div className="share-btns">
        <ShareBtn as="a" href={certificate_png && facebookLink} target="_blank" rel="noopener noreferrer" disabled={!certificate_png}>
          <AiFillFacebook size={22} color="var(--white)" />
        </ShareBtn>
        <ShareBtn as="a" href={certificate_png && twitterLink} target="_blank" rel="noopener noreferrer" disabled={!certificate_png}>
          <AiFillTwitterSquare size={22} color="var(--white)" />
        </ShareBtn>
        <ShareBtn disabled={!certificate_png}>
          <Share
            url={url}
            title={title}
            text={twitterMessage}
            position="bottomRight"
            color="var(--white)"
            disabled={!certificate_png}
          />
        </ShareBtn>
      </div>
    </CertificateSocialStyled>
  )
}

export default CertificateSocial
